import { render } from "./DivisionPlanDetailsComponent.vue?vue&type=template&id=22131799"
import script from "./DivisionPlanDetailsComponent.vue?vue&type=script&lang=js"
export * from "./DivisionPlanDetailsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__